var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeftArrowCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11613",
    "data-name": "Group 11613",
    transform: "translate(-644 -498)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_58",
    "data-name": "Ellipse 58",
    transform: "translate(644 498)",
    fill: "#fff",
    stroke: "#393939",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.5,
    r: 16.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.5,
    r: 15.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-arrow-back",
    "data-name": "Icon ionic-ios-arrow-back",
    d: "M13.414,12.467l4.749-4.745a.9.9,0,0,0-1.27-1.267l-5.38,5.376a.9.9,0,0,0-.026,1.237l5.4,5.414a.9.9,0,1,0,1.27-1.267Z",
    transform: "translate(645.749 501.807)",
    fill: "#0094d1"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrowCircle);
export default __webpack_public_path__ + "static/media/leftArrowCircle.b7a09187208401f54c5cd45f34ded3ce.svg";
export { ForwardRef as ReactComponent };